var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlacks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.966,
    height: 56,
    viewBox: "0 0 56.966 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.877 4.263)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.948,3.125l-.882,46.044H26.245L23.6,18.473l-2.646,30.7H12.132L11.25,3.125Z",
    transform: "translate(-11.25 -3.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.313,5.625H35.834",
    transform: "translate(-11.224 -2.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,3.125V14.21",
    transform: "translate(-7.651 -3.125)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 3.264,
    y2: 6.054,
    transform: "translate(21.17 5.969)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.264,
    y2: 6.054,
    transform: "translate(0.265 5.969)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 56.966,
    height: 55.067
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlacks);
export default __webpack_public_path__ + "static/media/Slacks.b7266b2b6e997b12e3b05ca07b09cc48.svg";
export { ForwardRef as ReactComponent };